// extracted by mini-css-extract-plugin
module.exports = {"product-row-placeholder":"product-row-placeholder--e0nlw"};